import axios from "axios";

const endpoint_url = "/message/messageBlastHistory/list";

const getMessageBlastHistory = (parameters) => {
  return new Promise((resolve, reject) => {
    axios
      .get(endpoint_url, { params: parameters })
      .then((response) => resolve(response.data))
      .catch((error) => {
        return reject(error.response.data);
      });
  });
};

export default getMessageBlastHistory;
